@if (initialized && formGroup) {

  <div class="p-2" [formGroup]="formGroup">
    <div class="mx-auto">
      <div class="surface-card border-round-2xl w-full">

<!--        <div class="flex justify-content-center mb-5">-->
<!--        <span class="w-6rem h-6rem border-circle flex justify-content-center align-items-center bg-orange-50">-->
<!--          <i class="pi pi-trash text-orange-600 text-5xl"></i>-->
<!--        </span>-->
<!--        </div>-->

<!--        <div class="text-center mb-6">-->
<!--          <div class="text-color text-3xl font-semibold mb-2">Account entfernen</div>-->
<!--          <span-->
<!--            class="text-600 font-medium line-height-3 text-color-secondary">Achtung: Dein KLAUS-Konto wird gelöscht!</span>-->
<!--        </div>-->

        <div class="text-center mb-6">
          <span>
<!--            Du wirst <span class="font-semibold">VOLLSTÄNDIGEN ZUGRIFF VERLIEREN</span> auf <span class="font-semibold">KLAUS</span>. Du wirst <span class="font-semibold">NICHT MEHR IN DER LAGE SEIN DICH EINZULOGGEN</span> und dein Benutzerkonto wird gelöscht.-->
<!--            Wenn du dein Konto löschst, verlierst du den vollständigen Zugriff auf KLAUS.-->
<!--            Danach kannst du dich nicht mehr einloggen, und alle deine Daten werden dauerhaft entfernt.-->
<!--            Bist du sicher, dass du fortfahren möchtest?-->
            Wenn du dein Konto löschst, verlierst du den vollständigen Zugriff auf deinen Account. Eine Anmeldung ist danach nicht mehr möglich.
          </span>
        </div>

        <div class="my-4">
          <label for="confirmText" class="block text-900 mb-2">
            Um dein Konto zu löschen, gib hier „Lösche mein Konto“ ein.
<!--            Um Ihr Konto zu löschen, geben Sie bitte "lösche mein-->
<!--            Konto" ein.-->
          </label>
          <input (input)="handleCheckText()" class="w-full" id="confirmText" formControlName="confirmText" pInputText
                 placeholder=""/>
        </div>

        <div class="my-2">
          <label for="password" class="block text-900 font-medium mb-2">Passwort</label>
          <div style="height: 0; overflow: hidden;">
            <input type="password" name="fakePassword" autocomplete="new-password" tabindex="-1"/>
          </div>
          <p-password id="password" formControlName="password"
                      placeholder="Passwort eingeben" styleClass="w-full" inputStyleClass="w-full"
                      [toggleMask]="true" [feedback]="false"></p-password>
        </div>

        <p-divider></p-divider>

        <div class="flex justify-content-end">
          <!--          <p-button class="w-10rem" [disabled]="!formGroup.valid"-->
          <!--                  severity="danger" pRipple label="Konto löschen" (click)="handleDeactivateAccount()"></p-button>-->

          <app-button [busy]="busy"
                      [disabled]="!formGroup.valid"
                      [label]="'Konto löschen'"
                      [class]="'w-10rem'"
                      [severity]="'danger'"
                      [showIcon]="false"
                      (onClick)="handleDeactivateAccount()">
          </app-button>

        </div>

      </div>
    </div>


  </div>

}
